import { render, staticRenderFns } from "./CardTotalizadoresLaudosDashboard.vue?vue&type=template&id=daffde3e&scoped=true&lang=pug"
import script from "./CardTotalizadoresLaudosDashboard.vue?vue&type=script&lang=js"
export * from "./CardTotalizadoresLaudosDashboard.vue?vue&type=script&lang=js"
import style0 from "./CardTotalizadoresLaudosDashboard.vue?vue&type=style&index=0&id=daffde3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daffde3e",
  null
  
)

export default component.exports